export type LibraryMaterial = {
  id: number;
  title: string;
  href: string;
  downloadLabel?: string;
};

const BASE = `${process.env.PUBLIC_URL || ''}/docs/exporter-library`;

export const LIBRARY_MATERIALS: LibraryMaterial[] = [
  {
    id: 1,
    title: 'Френдшоринг в мировой торговле',
    href: `${BASE}/01-friendshoring.pdf`,
  },
  {
    id: 2,
    title: 'Актуальные вопросы расчетов',
    href: `${BASE}/02-settlements.pdf`,
  },
  {
    id: 3,
    title: 'Гибридные логистические цепочки',
    href: `${BASE}/03-hybrid-logistics.pdf`,
  },
  {
    id: 4,
    title: 'Чек-лист по проверке контрагентов',
    href: `${BASE}/04-counterparties-checklist.pdf`,
  },
  {
    id: 5,
    title: 'Стратегия Медицинская промышленность',
    href: `${BASE}/05-strategy-medical.pdf`,
  },
  {
    id: 6,
    title: 'Стратегия Фармацевтическая промышленность',
    href: `${BASE}/06-strategy-pharma.pdf`,
  },
  {
    id: 7,
    title: 'Стратегия Энергетическое машиностроение 2',
    href: `${BASE}/07-strategy-energy-engineering.pdf`,
  },
  {
    id: 8,
    title: 'Стратегия радиоэлектроника',
    href: `${BASE}/08-strategy-radioelectronics.pdf`,
  },
  {
    id: 9,
    title: 'Стратегия Кабельная промышленность',
    href: `${BASE}/09-strategy-cable.pdf`,
  },
  {
    id: 10,
    title: 'Стратегия ПКП',
    href: `${BASE}/10-strategy-pkp.pdf`,
  },
  {
    id: 11,
    title: 'Дайджест - Египет',
    href: `${BASE}/11-digest-egypt.pdf`,
  },
  {
    id: 12,
    title: 'Стратегия - Вьетнам',
    href: `${BASE}/12-strategy-vietnam.pdf`,
  },
  {
    id: 13,
    title: 'Дайджест - Вьетнам',
    href: `${BASE}/13-digest-vietnam.pdf`,
  },
  {
    id: 14,
    title: 'Дайджест - Индия',
    href: `${BASE}/14-digest-india.pdf`,
  },
  {
    id: 15,
    title: 'Дайджест - Турецкая Республика',
    href: `${BASE}/15-digest-turkey.pdf`,
  },
  {
    id: 16,
    title: 'Стратегия экспорта - Индия',
    href: `${BASE}/16-strategy-export-india.pdf`,
  },
  {
    id: 17,
    title: 'Типовой договор ВЭД Моспром',
    href: `${BASE}/17-ved-contract-template.docx`,
    downloadLabel: 'Скачать документ (DOCX)',
  },
  {
    id: 18,
    title: 'Аналитика Индия Косметика',
    href: `${BASE}/18-analytics-india-cosmetics.pdf`,
  },
];
